export default "__VITE_ASSET__732182e7__"